import React, { useState } from "react";

import styled from "styled-components";

import Icon from "components/atoms/Icon";
import Alert from "components/atoms/alert/Alert";
import Button from "components/atoms/button";
import useToast from "components/atoms/toast/useToast";

import NavigatorFolderTreeView from "components/organisms/navigator/NavigatorFolderTreeView";
import AbstractModal from "components/page/modal/AbstractModal";

import { useNavigatorFolderResourcesCreate } from "hooks/queries/useNavigator";

const Container = styled.div`
    width: 100%;
`;

const FolderContainer = styled.div`
    min-height: 300px;
`;

const NormalView = styled.div`
    display: flex;
    padding: 8px;
    width: 100%;
    min-height: 240px;
    max-height: 320px;
    background-color: var(--color-Base1);
    border-radius: 4px;
    overflow: hidden;
`;

const FolderAddButtonWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    margin: 16px 0 0 0;
`;

function NavigatorFolderEditModal({ exitModal, resources, selectedFolderId = "" }) {
    const folderResourcesCreate = useNavigatorFolderResourcesCreate();
    const [showFolderAddModal, setShowFolderAddModal] = useState({
        type: "",
    });
    const [selectedItem, setSelectedItem] = useState(selectedFolderId ? [selectedFolderId] : []);
    const { setToast } = useToast();

    const handleApply = () => {
        folderResourcesCreate.mutate(
            {
                folder_id: selectedItem[0] || null,
                resources,
            },
            {
                onSuccess: () => {
                    exitModal();
                    setToast("선택한 폴더로 이동되었습니다.", "info");
                },
                onError: () => {
                    Alert("warn", "폴더 연결 실패", "폴더 연결에 실패했습니다.");
                },
            },
        );
    };

    return (
        <AbstractModal
            modalTitle="폴더 선택"
            width={480}
            exitModal={exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "적용",
                leftOnClick: exitModal,
                rightOnClick: handleApply,
            }}
        >
            <Container>
                <FolderContainer>
                    <FolderAddButtonWrap>
                        <Button
                            width={"100px"}
                            height={"24px"}
                            bgColor={"var(--color-Button1)"}
                            hoverBgColor={"var(--color-ButtonHover1)"}
                            fontColor={"var(--color-White)"}
                            buttonText={"새 폴더"}
                            onClick={() =>
                                setShowFolderAddModal({
                                    type: "create",
                                    parentIndex: selectedItem[0] ? selectedItem[0] : null,
                                })
                            }
                            margin={"0 0 10px 0"}
                        >
                            <Icon name={"plus"} size={"12"} color={"var(--color-White)"} />
                        </Button>
                    </FolderAddButtonWrap>

                    <NormalView>
                        <NavigatorFolderTreeView
                            treeId="navigator-folder-edit-view"
                            allLabel="모든 연구자료"
                            searchParams={{
                                folder: selectedItem[0],
                            }}
                            onSelectItems={(selectedItems) => {
                                setSelectedItem(selectedItems);
                            }}
                            showFolderAddModal={showFolderAddModal}
                            setShowFolderAddModal={setShowFolderAddModal}
                        />
                    </NormalView>
                </FolderContainer>
            </Container>
        </AbstractModal>
    );
}

export default NavigatorFolderEditModal;
